import AxiosInstance from '../../../http-config'
import { ConfigOperacionBalance, EnumTipoOperacion } from '../..'
import { getAppConfigurationValue } from '../../../../redux'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'

export const apiFetchConfigOperacionBalanceByOperationType = async (
  operationTypes: EnumTipoOperacion[]
): Promise<ConfigOperacionBalance[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)
  const operationTypesFilter = operationTypes?.map(id => `tipoOperacion eq '${id}'`)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/odata/ConfigOperacionesBalance?api-version=1.0&$filter=(${operationTypesFilter?.join(
      ' or '
    )}) `
  ).then(response => {
    return response.data.value
  })
}
